import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import ResortInner from '../Components/Resort/ResortInner'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import SEO from '../Components/SEO/SEO'

function Resort() {
    return (
        <>
            <SEO 
                title="Resorts - Tourm Travel Agency"
                description="Explore our luxury resorts and accommodations. Find the perfect place to stay for your vacation."
                url="/resort"
            />
            <HeaderOne />
            <Breadcrumb
                title="Resort"
            />
            <ResortInner />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default Resort
